import {
  calculateColumnWidth,
  mapColumnTypes,
  TYPES,
} from "@/react/components/table/columns";
import { getColumnDef } from "@/react/schema/schemaFields";
import selectColumnFactory from "@/react/components/table/components/selectColumnFactory";
import MediaTypes from "@/react/features/vcc/types/mediaTypes";

import { PostProcessingTimeout, SLAEvaluationInterval } from "../../schema";

import schema from "./schema";

const SLA_EVALUATION_INTERVAL_OPTIONS = Object.freeze({
  [SLAEvaluationInterval.FIVE_MINUTES]: "5 minutes",
  [SLAEvaluationInterval.SIX_MINUTES]: "6 minutes",
  [SLAEvaluationInterval.TEN_MINUTES]: "10 minutes",
  [SLAEvaluationInterval.FIFTEEN_MINUTES]: "15 minutes",
  [SLAEvaluationInterval.TWENTY_MINUTES]: "20 minutes",
  [SLAEvaluationInterval.TWENTY_FIVE_MINUTES]: "25 minutes",
  [SLAEvaluationInterval.THIRTY_MINUTES]: "30 minutes",
  [SLAEvaluationInterval.FORTY_FIVE_MINUTES]: "45 minutes",
  [SLAEvaluationInterval.ONE_HOUR]: "1 hour",
  [SLAEvaluationInterval.TWO_HOURS]: "2 hours",
  [SLAEvaluationInterval.THREE_HOURS]: "3 hours",
  [SLAEvaluationInterval.FOUR_HOURS]: "4 hours",
  [SLAEvaluationInterval.FIVE_HOURS]: "5 hours",
  [SLAEvaluationInterval.SIX_HOURS]: "6 hours",
  [SLAEvaluationInterval.TWELVE_HOURS]: "12 hours",
  [SLAEvaluationInterval.ONE_DAY]: "1 day",
  [SLAEvaluationInterval.TWO_DAYS]: "2 days",
  [SLAEvaluationInterval.THREE_DAYS]: "3 days",
});

const POST_PROCESSING_TIMEOUT_OPTIONS = Object.freeze({
  [PostProcessingTimeout.DISABLE]: "Disable",
  [PostProcessingTimeout.IMMEDIATE]: "Immediate",
  [PostProcessingTimeout.FIVE_SECONDS]: "5 seconds",
  [PostProcessingTimeout.TEN_SECONDS]: "10 seconds",
  [PostProcessingTimeout.FIFTEEN_SECONDS]: "15 seconds",
  [PostProcessingTimeout.TWENTY_SECONDS]: "20 seconds",
  [PostProcessingTimeout.TWENTY_FIVE_SECONDS]: "25 seconds",
  [PostProcessingTimeout.THIRTY_SECONDS]: "30 seconds",
  [PostProcessingTimeout.FORTY_SECONDS]: "40 seconds",
  [PostProcessingTimeout.FIFTY_SECONDS]: "50 seconds",
  [PostProcessingTimeout.ONE_MINUTE]: "1 minute",
  [PostProcessingTimeout.TWO_MINUTES]: "2 minutes",
  [PostProcessingTimeout.THREE_MINUTES]: "3 minutes",
  [PostProcessingTimeout.FOUR_MINUTES]: "4 minutes",
  [PostProcessingTimeout.FIVE_MINUTES]: "5 minutes",
  [PostProcessingTimeout.TEN_MINUTES]: "10 minutes",
  [PostProcessingTimeout.FIFTEEN_MINUTES]: "15 minutes",
  [PostProcessingTimeout.THIRTY_MINUTES]: "30 minutes",
  [PostProcessingTimeout.FORTY_FIVE_MINUTES]: "45 minutes",
  [PostProcessingTimeout.ONE_HOUR]: "1 hour",
});

export const getBaseQueueColumns = (schema) => [
  {
    ...getColumnDef(schema.fields.id, "ID"),
    type: TYPES.ID,
    defaultHidden: true,
  },
  {
    ...getColumnDef(schema.fields.name, "Name"),
    type: TYPES.STRING,
    sticky: true,
  },
  {
    ...getColumnDef(schema.fields.media_type, "Media Type"),
    type: TYPES.SELECT,
    options: {
      [MediaTypes.CHAT]: MediaTypes.CHAT,
      [MediaTypes.EMAIL]: MediaTypes.EMAIL,
      [MediaTypes.INBOUND_PHONE]: MediaTypes.INBOUND_PHONE,
      [MediaTypes.OUTBOUND_PHONE]: MediaTypes.OUTBOUND_PHONE,
      [MediaTypes.VOICEMAIL]: MediaTypes.VOICEMAIL,
    },
  },
  {
    ...getColumnDef(schema.fields.is_enabled, "Is Enabled"),
    type: TYPES.BOOLEAN,
  },
  {
    ...getColumnDef(schema.fields.default_priority, "Default Priority"),
    type: TYPES.NUMBER,
  },
  {
    ...getColumnDef(
      schema.fields.default_interaction_priority,
      "Default Interaction Priority"
    ),
    type: TYPES.NUMBER,
  },
  {
    ...getColumnDef(
      schema.fields.post_processing_timeout,
      "Post Processing Timeout"
    ),
    type: TYPES.SELECT,
    options: POST_PROCESSING_TIMEOUT_OPTIONS,
  },
  {
    ...getColumnDef(
      schema.fields.sla_interaction_percentage,
      "SLA Interaction Percentage"
    ),
    type: TYPES.NUMBER,
  },
  {
    ...getColumnDef(schema.fields.sla_interaction_time, "SLA Interaction Time"),
    type: TYPES.DURATION,
  },
  {
    ...getColumnDef(
      schema.fields.sla_evaluation_interval,
      "SLA Evaluation Interval"
    ),
    type: TYPES.SELECT,
    options: SLA_EVALUATION_INTERVAL_OPTIONS,
  },
  {
    ...getColumnDef(
      schema.fields.sla_notification_enabled,
      "SLA Notification Enabled"
    ),
    type: TYPES.BOOLEAN,
  },
  {
    ...getColumnDef(schema.fields.description, "Description"),
    type: TYPES.STRING,
  },
];

const columnDefinition = () =>
  calculateColumnWidth([
    selectColumnFactory(),
    ...getBaseQueueColumns(schema).map(mapColumnTypes),
  ]);

export default columnDefinition;
